export const skillGroups = [
  {
    title: 'Back-End Development',
    description: 'Designing maintainable services, integrations, and data flows.',
    items: ['C#', 'Data Structures & Algorithms', 'MySQL', 'SQL Server', 'PostgreSQL']
  },
  {
    title: 'Front-End Development',
    description: 'Building responsive interfaces that stay fast and accessible.',
    items: ['JavaScript', 'React.js']
  },
  {
    title: 'Platforms',
    description: 'Delivering reliable deployments across diverse environments.',
    items: ['Windows', 'Linux']
  },
  {
    title: 'Collaboration',
    description: 'Keeping teams aligned through transparent process and tooling.',
    items: ['Git', 'Jira']
  }
];

export const skillKeywords = Array.from(
  new Set(skillGroups.flatMap(group => group.items))
);
